var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DxForm',{attrs:{"id":"cropsForm","caption":"Crops Form"}},[_c('DxGroupItem',[_c('DxSimpleItem',{attrs:{"data-field":_vm.$t('DxCrops_DxSimpleItem_cropsSelector_dataField'),"editor-options":{
          items: _vm.cropsOptions,
          searchEnabled: true,
          searchTimeout: _vm.searchTimeoutOption,
          minSearchLength: _vm.minSearchLengthOption,
          showDataBeforeSearch: _vm.showDataBeforeSearchOption,
          onValueChanged: _vm.cropsValueChanged,
          value: _vm.initialCrops,
        },"editor-type":"dxTagBox","name":"cropsSelector"}},[_c('DxRequiredRule',{attrs:{"message":_vm.$t('Required_message')}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }